module.exports = __webpack_public_path__ + "static/media/menu14.c79840e2.jpg";